<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="{ name: 'newAnalystCoverage' }">
          <v-btn color="primary">{{ $t('analyst_coverage.new_analyst_coverage') }}</v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <CorrectDataTable
          :table-headers="headers"
          :table-data="analyst_coverage_data"
          :page-limit="current_limit"
          :page="current_page"
          :page-limit-options="tablePageLimitOptions"
          :item-total="total_items"
          :is-loading="load_table"
          :enable-search="false"
          :enable-filter="false"
          :enable-date-range="false"
          :enable-clear-all="false"
          :disable-pagination="load_table"
          :disable-sort="true"
          @options-update="onTableChange"
        ></CorrectDataTable>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getData } from '@/api'
import CorrectDataTable from '@/components/CorrectDataTable.vue'
import { globalFunc } from '@/global'
export default {
  name: 'AnalystCoverage',
  components: {
    CorrectDataTable,
  },
  mixins: [globalFunc],
  data: () => ({
    headers: [],
    analyst_coverage_data: [],
    load_table: true,
    total_items: 0,
    current_page: 1,
    current_limit: 10,
    options: {},
    tablePageLimitOptions: [10, 20, 50],
  }),
  methods: {
    initializeHeader() {
      this.headers = [
        {
          text: this.$t('analyst_coverage.company'),
          value: 'company',
        },
        {
          text: this.$t('analyst_coverage.analyst'),
          value: 'analyst',
        },
        {
          text: this.$t('analyst_coverage.email'),
          value: 'email',
        },
        { text: '', value: 'analyst_coverage_button' },
      ]
    },
    async getAnalystCoverageData() {
      try {
        this.load_table = true

        let params = new URLSearchParams()
        params.set(
          'get_all_data_by_data_type',
          JSON.stringify({
            data_type: 'analyst_coverage_data',
            filter_page: this.current_page - 1,
            filter_limit: this.current_limit,
          }),
        )

        let analyst_coverage = await getData(params)

        if (Array.isArray(analyst_coverage)) {
          this.total_items = 0
          this.analyst_coverage_data = []
        } else {
          this.total_items = analyst_coverage.item_count

          this.analyst_coverage_data = analyst_coverage.item_list
        }

        this.load_table = false
      } catch (error) {
        globalFunc.log(error)
        this.load_table = false
      }
    },
    onTableChange(options) {
      if (options.itemsPerPage !== this.current_limit) {
        this.current_page = 1 // reset to first page if view options changed
      } else {
        this.current_page = options.page
      }

      this.current_limit = options.itemsPerPage
      this.getAnalystCoverageData()
    },
  },
  created() {
    this.initializeHeader()
    this.getAnalystCoverageData()
  },
}
</script>
